module.exports = __webpack_public_path__ + "static/img/img19.4d14aba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img19.png
// module id = VmFV
// module chunks = 1